export const fileUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http") || p.startsWith("/")) return p;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${p}`;
};
